"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireDefault(require("react"));
var _styledComponents = _interopRequireDefault(require("styled-components"));
var _propTypes = _interopRequireDefault(require("prop-types"));
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
(function () {
  var enterModule = typeof reactHotLoaderGlobal !== 'undefined' ? reactHotLoaderGlobal.enterModule : undefined;
  enterModule && enterModule(module);
})();
var __signature__ = typeof reactHotLoaderGlobal !== 'undefined' ? reactHotLoaderGlobal.default.signature : function (a) {
  return a;
};
const StyledPath = _styledComponents.default.path.withConfig({
  displayName: "IconUser__StyledPath",
  componentId: "sc-1bcm97r-0"
})(["", ""], ({
  pFill,
  theme
}) => `fill: ${typeof pFill === 'function' ? pFill(theme) : pFill}`);
const IconUser = ({
  width,
  height,
  fill
}) => {
  return /*#__PURE__*/_react.default.createElement("svg", {
    width: width,
    height: height,
    viewBox: "0 0 35 35",
    version: "1.1",
    xmlns: "http://www.w3.org/2000/svg"
  }, /*#__PURE__*/_react.default.createElement(StyledPath, {
    d: "M17.14608,4.36983782e-13 C26.6155917,4.36983782e-13 34.29216,7.67656829 34.29216,17.14608 C34.29216,26.6155987 26.6155917,34.29216 17.14608,34.29216 C7.67656129,34.29216 -1.77635684e-14,26.6155987 -1.77635684e-14,17.14608 C-1.77635684e-14,7.67656829 7.67656129,4.36983782e-13 17.14608,4.36983782e-13 Z M22.1116081,20.8702296 L12.1805496,20.8702296 C8.79167235,20.8702296 6.02340157,23.615254 5.97840186,26.9949143 C8.70626621,30.0859373 12.6882252,32.0426736 17.14608,32.0426736 C21.6039348,32.0426736 25.5858238,30.0859373 28.3137535,26.9949143 C28.2688704,23.615254 25.50056,20.8702296 22.1116081,20.8702296 Z M17.14608,5.97362429 C13.7322581,5.97362429 10.9391664,8.76673238 10.9391664,12.1805519 C10.9391664,15.5943714 13.7322581,18.3874632 17.14608,18.3874632 C20.5599019,18.3874632 23.3529843,15.5943714 23.3529843,12.1805519 C23.3529843,8.76673238 20.5599019,5.97362429 17.14608,5.97362429 Z",
    pFill: fill
  }));
};
IconUser.propTypes = {
  width: _propTypes.default.string,
  height: _propTypes.default.string,
  fill: _propTypes.default.oneOfType([_propTypes.default.string, _propTypes.default.func])
};
IconUser.defaultProps = {
  width: '34',
  height: '34',
  fill: 'white'
};
const _default = IconUser;
var _default2 = exports.default = _default;
;
(function () {
  var reactHotLoader = typeof reactHotLoaderGlobal !== 'undefined' ? reactHotLoaderGlobal.default : undefined;
  if (!reactHotLoader) {
    return;
  }
  reactHotLoader.register(StyledPath, "StyledPath", "/Users/jake.clayton/frontend/ls-common-client/src/components/UserMenu/IconUser.js");
  reactHotLoader.register(IconUser, "IconUser", "/Users/jake.clayton/frontend/ls-common-client/src/components/UserMenu/IconUser.js");
  reactHotLoader.register(_default, "default", "/Users/jake.clayton/frontend/ls-common-client/src/components/UserMenu/IconUser.js");
})();
;
(function () {
  var leaveModule = typeof reactHotLoaderGlobal !== 'undefined' ? reactHotLoaderGlobal.leaveModule : undefined;
  leaveModule && leaveModule(module);
})();